import { render, staticRenderFns } from "./revokeModal.vue?vue&type=template&id=405757be&scoped=true&"
import script from "./revokeModal.vue?vue&type=script&lang=js&"
export * from "./revokeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405757be",
  null
  
)

export default component.exports